var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddNoteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/note"
  }, /*#__PURE__*/React.createElement("g", {
    id: "note"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.667 8.75V18.5C20.667 21.5 18.877 22.5 16.667 22.5H8.66699C6.45699 22.5 4.66699 21.5 4.66699 18.5V8.75C4.66699 5.5 6.45699 4.75 8.66699 4.75C8.66699 5.37 8.91697 5.93 9.32697 6.34C9.73697 6.75 10.297 7 10.917 7H14.417C15.657 7 16.667 5.99 16.667 4.75C18.877 4.75 20.667 5.5 20.667 8.75Z",
    stroke: "#FF852D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.667 4.75C16.667 5.99 15.657 7 14.417 7H10.917C10.297 7 9.73697 6.75 9.32697 6.34C8.91697 5.93 8.66699 5.37 8.66699 4.75C8.66699 3.51 9.67699 2.5 10.917 2.5H14.417C15.037 2.5 15.597 2.75 16.007 3.16C16.417 3.57 16.667 4.13 16.667 4.75Z",
    stroke: "#FF852D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.66699 13.5H12.667",
    stroke: "#FF852D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.66699 17.5H16.667",
    stroke: "#FF852D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNoteIcon);
export default __webpack_public_path__ + "static/media/add_note_icon.d672de33c72e500dab1c8d026e7543e5.svg";
export { ForwardRef as ReactComponent };